import ReportDefinitionItem from "../../../pages/Models/ReportDefinitionItem";
import {ReportDefinitionType} from "@/models/Enums";
import MassProduct from "@/models/server/MassProduct";

export default class SaveReportDefinitionRequest {

    public reportDefinitionId: string | null = null;

    public name: string = "";

    public items: ReportDefinitionItem[] = [];

    public reportDefinitionType: ReportDefinitionType = ReportDefinitionType.ReturnInspection;

    public massProducts: MassProduct[] | null = null;
}